import api from './api';

const pending = (message, cause) => Object.assign(new Error(message), {callOutcomePending:true, cause});
const matches = (actual, expected) => actual && actual.due_date === expected.due_date &&
  actual.due_time === expected.due_time && (actual.note || '').trim() === (expected.note || '').trim();

// Creation uses the existing transactional idempotency key. Updates are never
// blindly replayed: a lost reply is reconciled against the current reminder.
export async function executeQueuedFollowup(job, persist, canRun) {
  const {customer_id, opportunity_id, followup_id, followup, from_call, idempotency_key} = job.body;
  const guard = () => { if (!canRun()) throw pending('Anmeldung gewechselt. Wiedervorlage bleibt gespeichert.'); };
  guard();
  if (job.attempted && (followup_id || job.reviewExisting)) {
    const {data} = await api.get(`/contacts/${customer_id}/followup`);
    if ((!followup_id || data.followup?.id === followup_id) && matches(data.followup, followup)) return;
    throw pending('Wiedervorlage bitte am Kontakt prüfen. Gespeicherte Eingabe bleibt erhalten.');
  }
  if (Date.now() - job.createdAt > 23 * 60 * 60 * 1000) {
    throw pending('Ältere Wiedervorlage bitte am Kontakt prüfen. Keine automatische Wiederholung.');
  }
  guard();
  job.attempted = true; persist(job);
  const config = {timeout:30000, careerSessionId:job.session, callTiming:job.callTiming || null};
  let result;
  try {
    result = followup_id
      ? await api.patch(`/followups/${followup_id}`, followup, config)
      : await api.post('/followups', {customer_id, opportunity_id, type:'wiedervorlage',
          followup, from_call, idempotency_key}, config);
  } catch (error) {
    throw pending('Wiedervorlage noch nicht bestätigt. Eingabe bleibt gespeichert.', error);
  }
  if (result.data.existing || result.data.duplicate_ignored || !result.data.followup?.id) {
    job.reviewExisting = true; persist(job);
    throw pending('Wiedervorlage bitte am Kontakt prüfen. Keine vorhandenen Angaben überschrieben.');
  }
}
